import { Button, Dialog, Paper, Slider, Typography } from '@mui/material';
import React from 'react';
import { styled } from '../../../../components/styled';

export const ColoredPaper = styled(Paper)`
  background-color: ${(props) => props.theme.color.clientPrimary};
`;

const RAIL_HEIGHT = '8px';
const HANDLE_HEIGHT = '12px';

export const CenteredTimeDisplayTypography = styled(Typography)<{
  fontSize?: string;
}>`
  font-size: ${(props) => props.fontSize ?? '1.5rem'};
  position: fixed;
  left: 50%;
  transform: translate(-50%);
`;

export const StyledButton = styled(Button)`
  padding: 2px;
  margin: 0px;
  margin-bottom: 5px;
  min-width: 5px;
  z-index: 1000;
  background-color: white;
  border-radius: 20px;
  height: 15px;
  border: 1px solid black;

  &:hover {
    color: #f0f0f0;
  }
`;
export const StyledSlider = styled(Slider)({
  position: 'relative',
  padding: '5px 0',
  borderRadius: '6px',
  '-ms-touch-action': 'none',
  'touch-action': 'none',
  boxSizing: 'border-box',
  '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)',
  height: '22px',

  '& .MuiSlider-rail': {
    position: 'absolute',
    backgroundColor: '#e9e9e9',
    borderRadius: '6px',
    opacity: 1,
    height: RAIL_HEIGHT,
  },
  '& .MuiSlider-track': {
    position: 'absolute',
    left: 0,
    borderRadius: '6px',
    height: RAIL_HEIGHT,
    backgroundColor: 'rgb(27, 35, 126)',
  },
  '& .MuiSlider-thumb': {
    position: 'absolute',
    cursor: 'grab',
    borderRadius: '50%',
    border: 'solid 2px #96dbfa',
    backgroundColor: '#fff',
    touchAction: 'pan-x',
    height: HANDLE_HEIGHT,
    width: HANDLE_HEIGHT,
    borderColor: 'rgb(27, 35, 126)',
    '&:active': {
      borderColor: '#57c5f7',
      boxShadow: `0 0 0 5px #57c5f7`,
      cursor: 'grabbing',
    },
    '&:focus': {
      borderColor: '#57c5f7',
      boxShadow: `0 0 0 5px #96dbfa`,
      outline: 'none',
    },
    '&:hover': {
      borderColor: '#57c5f7',
    },
  },
  '& .MuiSlider-valueLabel': {
    padding: '6px 2px',
    minWidth: '24px',
    height: '24px',
    fontSize: '12px',
    lineHeight: '1',
    color: '#fff',
    textAlign: 'center',
    textDecoration: 'none',
    backgroundColor: '#6c6c6c',
    borderRadius: '6px',
    boxShadow: '0 0 4px #d9d9d9',
  },
});

export const TimeSliderDialog = ({
  opened,
  setOpened,
  children,
  ...props
}: {
  opened: boolean;
  setOpened: (val: boolean) => void;
  children: React.ReactNode;
  [key: string]: any;
}) => {
  return (
    <Dialog
      {...props}
      open={opened}
      onClose={() => setOpened(false)}
      keepMounted={true}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          margin: 0,
          overflow: 'visible',
          position: 'fixed',
          left: '50%',
          transform: 'translate(-50%, 0)',
          maxWidth: 'none',
        },
      }}
      TransitionProps={{
        style: {
          alignItems: 'flex-start',
        },
      }}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          width: '97vw',
          height: 'calc(100% - 35px)',
          marginTop: '35px',
          marginLeft: '3vw',
        },
      }}
      style={{
        width: '97vw',
        height: 'calc(100% - 35px)',
        marginTop: '35px',
        marginLeft: '3vw',
      }}
    >
      {children}
    </Dialog>
  );
};
